import { FC } from 'react'

import { clsx } from 'clsx'

import AsyncApiRenderer from '~/portal/components/ApiViewer/AsyncApiRenderer'
import SwaggerRenderer from '~/portal/components/ApiViewer/SwaggerRenderer'
import LastModifiedDate from '~/portal/components/LastModifiedDate'
import { AsyncAPIDefinition, OpenAPI2Definition, OpenAPI3Definition } from '~/portal/types/api.definitions'
import { SHUBApiDetails } from '~/shared/types/api'
import { APIRenderers, RoutingSettings } from '~/shared/types/portal'

interface ApiRendererProps {
  activeRenderer?: APIRenderers
  definition: OpenAPI2Definition | OpenAPI3Definition | AsyncAPIDefinition
  hash: string
  ref: HTMLDivElement | undefined
  isAdmin: boolean
  pathname: string
  isConsumerSide?: boolean
  lastModifiedDate?: string
  exploreUrl?: string
  SHUBApiDetails: SHUBApiDetails
  oasVersion: string
  routingSettings?: RoutingSettings
  ElementsRenderer: FC<{ definition: OpenAPI2Definition | OpenAPI3Definition; stacked: boolean; routingSettings?: RoutingSettings }>
}

export const ApiRenderer = ({
  activeRenderer,
  definition,
  hash,
  ref,
  isAdmin,
  pathname,
  isConsumerSide,
  lastModifiedDate,
  exploreUrl,
  SHUBApiDetails,
  oasVersion,
  routingSettings,
  ElementsRenderer,
}: ApiRendererProps) => {
  if (!ref) {
    return null
  }

  if (activeRenderer === APIRenderers.ASYNCAPI) {
    return (
      <div>
        <AsyncApiRenderer 
          definition={definition as AsyncAPIDefinition} 
          hash={decodeURIComponent(hash)} 
          containerRef={ref} 
          lastModifiedDate={lastModifiedDate} 
          isConsumerSide={isConsumerSide} 
        />
      </div>
    )
  }

  if (activeRenderer === APIRenderers.ELEMENTS) {
    return (
      <div id="elements-renderer" className={clsx('pt-6', isConsumerSide && 'md:px-3 xl:px-0 md:pt-9 xl:pt-6')}>
        <LastModifiedDate date={lastModifiedDate} className="pb-[0.7rem] px-6" />
        <ElementsRenderer
          definition={definition as OpenAPI2Definition | OpenAPI3Definition}
          stacked={isAdmin}
          routingSettings={routingSettings}
          key={pathname}
        />
      </div>
    )
  }

  return (
    <div className={clsx(isConsumerSide && 'md:p-3 xl:p-0 pb-4!')}>
      <SwaggerRenderer
        definition={definition as OpenAPI2Definition | OpenAPI3Definition}
        hash={decodeURIComponent(hash)}
        containerRef={ref}
        exploreUrl={exploreUrl}
        SHUBApiDetails={SHUBApiDetails}
        oasVersion={oasVersion}
        lastModifiedDate={lastModifiedDate}
        routingSettings={routingSettings}
      />
    </div>
  )
}
